import { HttpContextToken } from '@angular/common/http';

/**
 * Opt-out for mutating requests that must NOT hold the page — e.g. fire-and-forget
 * telemetry, logout, or a POST that is really a query (search/report endpoints
 * that use POST only to carry a body). Read by `PendingMutationInterceptor`
 * (`@application/http-client`), which re-exports it.
 *
 * It lives here, and not next to the interceptor, for the same reason as
 * `SKIP_FORBIDDEN_ELEVATION`: data-access libs can mark their requests without
 * importing `@application/http-client`, whose interceptors reach back into them
 * (through the auth store) and would close a dependency cycle.
 *
 * ```ts
 * this.http.post(url, body, {
 *   context: new HttpContext().set(SKIP_PENDING_MUTATION_GUARD, true),
 * });
 * ```
 */
export const SKIP_PENDING_MUTATION_GUARD = new HttpContextToken<boolean>(
  () => false
);
